module.exports = __webpack_public_path__ + "img/Shibtoshi.305c2db4.png";